<template>
  <div class="home">
    <div class="home1">村使馆详情</div>
    <div class="header">
      <img src="@/assets/csg.jpg" alt="">
    </div>
    <div class="header">
      <img src="@/assets/csg1.jpg" alt="">
    </div>
    <div class="header">
      <img src="@/assets/csg2.jpg" alt="">
    </div>
    <div class="tit">
      <div class="tit1">详情简介：</div>
      <div class="tit2">{{textToSpeak}}</div>
    </div>
    <button ref="clickMe" @click="speakText" style="display:none"></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textToSpeak:
        "小井峪村史馆位于古井南侧，面积近 300 平方米，馆内古香古色，通过展板、实物和数百张照片呈现小井峪的旧貌新颜，展出内容包括“砺程篇”“印迹篇”“硕果篇”三大篇章。 ",
    };
  },
  mounted() {
    this.$refs.clickMe.click();
    // 在组件创建时设置TTS监听路由变化
    this.unregisterHook = this.$router.afterEach((to, from) => {
      if (to !== from) {
        this.stopTTS();
      }
    });
  },

  methods: {
    // 播放
    speakText() {
      if ("speechSynthesis" in window) {
        const msg = new SpeechSynthesisUtterance(this.textToSpeak);
        // 设置语音合成的参数
        msg.lang = "zh-CN"; // 设置语言
        msg.rate = 1; // 设置语速
        msg.pitch = 1; // 设置音调
        msg.volume = 1; // 设置音量
        // 开始播放
        window.speechSynthesis.speak(msg);
        // 监听结束事件
        msg.onend = () => {};
      }
    },
    stopTTS() {
      window.speechSynthesis.cancel();
    },
  },
};
</script>


<style scoped>
.home1 {
  height: 50px;
  text-align: center;
  font-weight: 700;
  line-height: 3;
}

.header {
  width: 96%;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 50%;
  margin-bottom: 11px;
}

.header > img {
  width: 100%;
  height: 100%; /* 高度自动调整 */
  border-radius: 8px;
}

.tit {
  width: 95%;
  margin: 20px auto;
}

.tit1 {
  font-weight: 700;
  letter-spacing: 3px;
}

.tit2 {
  margin-top: 4%;
  line-height: 2.5;
  letter-spacing: 3px;
  text-indent: 2em;
}
</style>
